"use strict";
var angular = require("angular");

var module = angular.module("dashboard.module", ["common.module"]);
require("./states.js").configure(module);

module.controller("residentialDashboard.controller", require("./controllers/residentialDashboard.controller"));
module.factory("dashboard.service", require("./services/dashboard.service"));
module.component("iluDashboard", new (require("./components/iluDashboardComponent"))());
module.component("iluDashboardListDetails", new (require("./components/iluDashboardListDetailsComponent"))());